import { render, staticRenderFns } from "./ProgramEffectiveness.vue?vue&type=template&id=163bf090&scoped=true"
import script from "./ProgramEffectiveness.vue?vue&type=script&lang=js"
export * from "./ProgramEffectiveness.vue?vue&type=script&lang=js"
import style0 from "./ProgramEffectiveness.vue?vue&type=style&index=0&id=163bf090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bf090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VIcon,VLayout,VMenu})
